var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-button",class:_vm.classes,style:(_vm.style),on:{"click":_vm.onClick}},[(_vm.icon)?_c('img',{staticClass:"kd-button__icon",attrs:{"src":_vm.icon}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }